import { IClonableItem } from "../interfaces/clonable-item.interface";

export class ClonableItem<T> implements IClonableItem<T> {
    constructor(value?: T) {
        this.initValues(value);
    }

    getJSON() {
        return {};
    }

    clone() {
        const clone = new (this.constructor as any)(this.getJSON());

        return clone;
    }

    initValues(value?: T) {
        if (value) {
            this.initWithJSON(value);
        } else {
            this.initDefaultValues();
        }
    }

    initWithJSON(value: T, _skipStatistic?: boolean) {
        if (value) {
            Object.assign(this, value);
        }
    }

    initDefaultValues() { }

    protected initInstancesCollection(collectionName: string, constructor: any): void {
        if (!collectionName || !this[collectionName]) {
            return;
        }
        this[collectionName] = this[collectionName].map(data => new constructor(data));
    }
}
